function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartmenuEditpane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "48pt",
    height: "48pt",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 40.742188 11.695312 L 36.285156 7.21875 C 36.136719 7.070312 35.972656 6.929688 35.808594 6.804688 C 34.953125 6.148438 33.929688 5.800781 32.851562 5.800781 C 31.359375 5.800781 29.984375 6.460938 29.054688 7.617188 L 5.84375 30.726562 L 5.84375 41.996094 L 17.015625 42.199219 L 40.441406 18.875 C 40.523438 18.808594 40.597656 18.738281 40.675781 18.664062 C 42.613281 16.765625 42.648438 13.644531 40.742188 11.695312 Z M 15.714844 38.964844 L 9.054688 38.84375 L 9.054688 32.058594 L 27.144531 14.050781 L 33.917969 20.855469 Z M 38.367188 16.425781 L 36.191406 18.589844 L 29.421875 11.785156 L 31.386719 9.824219 L 31.53125 9.660156 C 32.070312 8.957031 33.140625 8.800781 33.863281 9.355469 C 33.921875 9.398438 33.972656 9.445312 34.015625 9.488281 L 38.457031 13.949219 C 39.117188 14.625 39.105469 15.710938 38.367188 16.425781 Z M 38.367188 16.425781 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartmenuEditpane);
export default __webpack_public_path__ + "static/media/Chart menu_edit pane.f1f4c275e8fe1babc31c5e29370c521c.svg";
export { ForwardRef as ReactComponent };